import { render } from "./WalletTransactionsListComponent.vue?vue&type=template&id=06512e10&scoped=true&ts=true"
import script from "./WalletTransactionsListComponent.vue?vue&type=script&lang=ts"
export * from "./WalletTransactionsListComponent.vue?vue&type=script&lang=ts"

import "./WalletTransactionsListComponent.vue?vue&type=style&index=0&id=06512e10&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06512e10"]])

export default __exports__